module.exports = "/_next/static/images/pe-ef9dac1d11d5a271b19330e27f679475.svg";